var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaginationArrow = function SvgPaginationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 28,
    viewBox: "0 0 16 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.7 3.46c.73-.8.73-2.08 0-2.87s-1.92-.79-2.66 0L1.3 12.16c-.73.8-.73 2.07 0 2.87l10.74 11.56c.74.8 1.93.8 2.66 0 .73-.79.73-2.07 0-2.86L5.28 13.6 14.7 3.46Z",
    clipRule: "evenodd"
  })));
};
export default SvgPaginationArrow;